/**
 * Whether a form holds changes not saved yet: a tap on the active tab asks before it throws them
 * away (B8). A form sets it while open and clears it when it closes.
 */
export const unsaved = { dirty: false };
